import createReducer from '../lib/createReducer';
import all from './altitudesData.json';

const initialYear = 2200;
const initialState = {
  all,
  value: all.find(({ year }) => year === initialYear).value,
  year: initialYear,
};

const SET_RUNNING_VALUE = 'ALTITUDES::SET_RUNNING_VALUE';
const SET_RUNNING_YEAR = 'ALTITUDES::SET_RUNNING_YEAR';

/**
 * Set altitude.
 * @param {!Number} value The altitude of the sea level.
 * @return {object} action.
 */
export const setAltitude = (value) => ({
  type: SET_RUNNING_VALUE,
  payload: value,
});

/**
 * Set year.
 * @param {!Number} year The year of the simulation.
 * @return {object} action.
 */
export const setYear = (year) => ({
  type: SET_RUNNING_YEAR,
  payload: year,
});

export default createReducer({
  [SET_RUNNING_VALUE]: (state, action) => ({
    ...state,
    value: action.payload,
  }),

  [SET_RUNNING_YEAR]: (state, action) => ({
    ...state,
    year: action.payload,
  }),
}, initialState);
